import { apiCall } from './gqlClient';
const CHECKSESSIONSFORSUBSCRIPTIONN_QUERY = "\n  query checkSessionsForSubscriptionN($request: CheckSessionsSubsNInput!) {\n    checkSessionsForSubscriptionN(request: $request)\n    {\n      userId\n\t\t\tstartActive\n\t\t\tendActive\n\t\t\tstartReserved\n\t\t\tendReserved\n      ...fragments\n    }\n  }";
export const checkSessionsForSubscriptionNApiCall = async function (_ref) {
  let {
    request
  } = _ref;
  let fragments = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;
  return apiCall({
    query: CHECKSESSIONSFORSUBSCRIPTIONN_QUERY,
    variables: {
      request
    },
    fragments
  });
};
const GETSUBSCRIPTIONSOFUSERINSPECIFICCLASS_QUERY = "\n  query getSubscriptionsOfUserInSpecificClass($classId: Int!, $userId: Int, $customerId: Int) {\n    getSubscriptionsOfUserInSpecificClass(classId: $classId, userId: $userId, customerId: $customerId)\n    {\n      id\n\t\t\tuserId\n\t\t\tserviceId\n\t\t\tproviderId\n\t\t\tclassId\n\t\t\tcreated\n\t\t\tupdated\n\t\t\ttotal\n\t\t\tstatus\n\t\t\temail\n\t\t\tcode\n\t\t\tappName\n\t\t\tonlineDiscount\n\t\t\tcancelled\n\t\t\tcancelledBy\n\t\t\tisItCancelledOnTime\n\t\t\tresourceEmail\n\t\t\tcancelledCounted\n\t\t\tpresence\n\t\t\tstartTime\n      ...fragments\n    }\n  }";
export const getSubscriptionsOfUserInSpecificClassApiCall = async function (_ref2) {
  let {
    classId,
    userId,
    customerId
  } = _ref2;
  let fragments = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;
  return apiCall({
    query: GETSUBSCRIPTIONSOFUSERINSPECIFICCLASS_QUERY,
    variables: {
      classId,
      userId,
      customerId
    },
    fragments
  });
};
const GETSUBSCRIPTIONPRICE_QUERY = "\n  query getSubscriptionPrice($request: SubscriptionPriceRequest!) {\n    getSubscriptionPrice(request: $request)\n    {\n      price\n\t\t\tdiscount\n\t\t\tpriceWithoutDiscount\n\t\t\tuserHasMembership\n\t\t\twaitingList\n      ...fragments\n    }\n  }";
export const getSubscriptionPriceApiCall = async function (_ref3) {
  let {
    request
  } = _ref3;
  let fragments = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;
  return apiCall({
    query: GETSUBSCRIPTIONPRICE_QUERY,
    variables: {
      request
    },
    fragments
  });
};
const GETSUBSCRIPTIONSBYSESSION_QUERY = "\n  query getSubscriptionsBySession($sessionId: Int!) {\n    getSubscriptionsBySession(sessionId: $sessionId)\n    {\n      id\n\t\t\tuserId\n\t\t\tserviceId\n\t\t\tproviderId\n\t\t\tclassId\n\t\t\tcreated\n\t\t\tupdated\n\t\t\ttotal\n\t\t\tstatus\n\t\t\temail\n\t\t\tcode\n\t\t\tappName\n\t\t\tonlineDiscount\n\t\t\tcancelled\n\t\t\tcancelledBy\n\t\t\tisItCancelledOnTime\n\t\t\tresourceEmail\n\t\t\tcancelledCounted\n\t\t\tpresence\n\t\t\tstartTime\n      ...fragments\n    }\n  }";
export const getSubscriptionsBySessionApiCall = async function (_ref4) {
  let {
    sessionId
  } = _ref4;
  let fragments = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;
  return apiCall({
    query: GETSUBSCRIPTIONSBYSESSION_QUERY,
    variables: {
      sessionId
    },
    fragments
  });
};
const GETCANCELEDSUBSCRIPTIONSBYSESSION_QUERY = "\n  query getCanceledSubscriptionsBySession($sessionId: Int!) {\n    getCanceledSubscriptionsBySession(sessionId: $sessionId)\n    {\n      id\n\t\t\tuserId\n\t\t\tserviceId\n\t\t\tproviderId\n\t\t\tclassId\n\t\t\tcreated\n\t\t\tupdated\n\t\t\ttotal\n\t\t\tstatus\n\t\t\temail\n\t\t\tcode\n\t\t\tappName\n\t\t\tonlineDiscount\n\t\t\tcancelled\n\t\t\tcancelledBy\n\t\t\tisItCancelledOnTime\n\t\t\tresourceEmail\n\t\t\tcancelledCounted\n\t\t\tpresence\n\t\t\tstartTime\n      ...fragments\n    }\n  }";
export const getCanceledSubscriptionsBySessionApiCall = async function (_ref5) {
  let {
    sessionId
  } = _ref5;
  let fragments = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;
  return apiCall({
    query: GETCANCELEDSUBSCRIPTIONSBYSESSION_QUERY,
    variables: {
      sessionId
    },
    fragments
  });
};
const GETSUBSCRIPTIONSSESSIONSFORMULTIPLECANCEL_QUERY = "\n  query getSubscriptionsSessionsForMultipleCancel($request: SubscriptionsForCancelInput!) {\n    getSubscriptionsSessionsForMultipleCancel(request: $request)\n  }";
export const getSubscriptionsSessionsForMultipleCancelApiCall = async _ref6 => {
  let {
    request
  } = _ref6;
  return apiCall({
    query: GETSUBSCRIPTIONSSESSIONSFORMULTIPLECANCEL_QUERY,
    variables: {
      request
    }
  });
};
const VALIDATEMULTIPLESESSIONSMEMBERSHIPRULES_QUERY = "\n  query validateMultipleSessionsMembershipRules($sessions: [Int]!, $classId: Int!, $userId: Int, $customerId: Int) {\n    validateMultipleSessionsMembershipRules(sessions: $sessions, classId: $classId, userId: $userId, customerId: $customerId)\n    {\n      message\n\t\t\tfailedPeriods\n      ...fragments\n    }\n  }";
export const validateMultipleSessionsMembershipRulesApiCall = async function (_ref7) {
  let {
    sessions,
    classId,
    userId,
    customerId
  } = _ref7;
  let fragments = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;
  return apiCall({
    query: VALIDATEMULTIPLESESSIONSMEMBERSHIPRULES_QUERY,
    variables: {
      sessions,
      classId,
      userId,
      customerId
    },
    fragments
  });
};
const CREATESUBSCRIPTION_QUERY = "\n  mutation createSubscription($request: SubscriptionCreateRequest) {\n    createSubscription(request: $request)\n    {\n      success\n\t\t\tmessage\n\t\t\tid\n\t\t\tid2\n\t\t\tname\n\t\t\tstatus\n      ...fragments\n    }\n  }";
export const createSubscriptionApiCall = async function (_ref8) {
  let {
    request
  } = _ref8;
  let fragments = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;
  return apiCall({
    query: CREATESUBSCRIPTION_QUERY,
    variables: {
      request
    },
    fragments
  });
};
const CREATESUBSCRIPTIONONPASTEVENT_QUERY = "\n  mutation createSubscriptionOnPastEvent($request: SubscriptionCreateRequest) {\n    createSubscriptionOnPastEvent(request: $request)\n    {\n      success\n\t\t\tmessage\n\t\t\tid\n\t\t\tid2\n\t\t\tname\n\t\t\tstatus\n      ...fragments\n    }\n  }";
export const createSubscriptionOnPastEventApiCall = async function (_ref9) {
  let {
    request
  } = _ref9;
  let fragments = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;
  return apiCall({
    query: CREATESUBSCRIPTIONONPASTEVENT_QUERY,
    variables: {
      request
    },
    fragments
  });
};
const CREATESUBSCRIPTIONASANONYMOUS_QUERY = "\n  mutation createSubscriptionAsAnonymous($classId: Int!, $sessions: [Int]!, $email: String!, $onlyBook: Boolean, $firstname: String, $lastname: String, $phone: String) {\n    createSubscriptionAsAnonymous(classId: $classId, sessions: $sessions, email: $email, onlyBook: $onlyBook, firstname: $firstname, lastname: $lastname, phone: $phone)\n    {\n      id\n\t\t\tmessage\n\t\t\tsuccess\n\t\t\tamount\n\t\t\tamountCents\n\t\t\tclientSecret\n\t\t\tstripeAccount\n\t\t\tofferId\n\t\t\tproductId\n      ...fragments\n    }\n  }";
export const createSubscriptionAsAnonymousApiCall = async function (_ref10) {
  let {
    classId,
    sessions,
    email,
    onlyBook,
    firstname,
    lastname,
    phone
  } = _ref10;
  let fragments = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;
  return apiCall({
    query: CREATESUBSCRIPTIONASANONYMOUS_QUERY,
    variables: {
      classId,
      sessions,
      email,
      onlyBook,
      firstname,
      lastname,
      phone
    },
    fragments
  });
};
const CONFIRMSUBSCRIPTION_QUERY = "\n  mutation confirmSubscription($code: JSON!) {\n    confirmSubscription(code: $code)\n  }";
export const confirmSubscriptionApiCall = async _ref11 => {
  let {
    code
  } = _ref11;
  return apiCall({
    query: CONFIRMSUBSCRIPTION_QUERY,
    variables: {
      code
    }
  });
};
const ACTIVATESUBSCRIPTION_QUERY = "\n  mutation activateSubscription($id: Int!) {\n    activateSubscription(id: $id)\n    {\n      success\n\t\t\tmessage\n\t\t\tid\n\t\t\tid2\n\t\t\tname\n\t\t\tstatus\n      ...fragments\n    }\n  }";
export const activateSubscriptionApiCall = async function (_ref12) {
  let {
    id
  } = _ref12;
  let fragments = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;
  return apiCall({
    query: ACTIVATESUBSCRIPTION_QUERY,
    variables: {
      id
    },
    fragments
  });
};
const CANCELSUBSCRIPTION_QUERY = "\n  mutation cancelSubscription($subscriptionId: Int!) {\n    cancelSubscription(subscriptionId: $subscriptionId)\n    {\n      id\n\t\t\tsuccess\n\t\t\tmessage\n\t\t\treimbursedSessionsCount\n      ...fragments\n    }\n  }";
export const cancelSubscriptionApiCall = async function (_ref13) {
  let {
    subscriptionId
  } = _ref13;
  let fragments = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;
  return apiCall({
    query: CANCELSUBSCRIPTION_QUERY,
    variables: {
      subscriptionId
    },
    fragments
  });
};
const CANCELSUBSCRIPTIONSESSION_QUERY = "\n  mutation cancelSubscriptionSession($subscriptionId: Int!, $sessionId: Int!) {\n    cancelSubscriptionSession(subscriptionId: $subscriptionId, sessionId: $sessionId)\n    {\n      id\n\t\t\tsuccess\n\t\t\tmessage\n\t\t\treimbursedSessionsCount\n      ...fragments\n    }\n  }";
export const cancelSubscriptionSessionApiCall = async function (_ref14) {
  let {
    subscriptionId,
    sessionId
  } = _ref14;
  let fragments = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;
  return apiCall({
    query: CANCELSUBSCRIPTIONSESSION_QUERY,
    variables: {
      subscriptionId,
      sessionId
    },
    fragments
  });
};
const CREATESESSIONSFORSUBSCRIPTIONN_QUERY = "\n  mutation createSessionsForSubscriptionN($request: CreateSessionsSubscriptionNInput!) {\n    createSessionsForSubscriptionN(request: $request)\n    {\n      success\n\t\t\tmessage\n\t\t\tid\n\t\t\tid2\n\t\t\tname\n\t\t\tstatus\n      ...fragments\n    }\n  }";
export const createSessionsForSubscriptionNApiCall = async function (_ref15) {
  let {
    request
  } = _ref15;
  let fragments = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;
  return apiCall({
    query: CREATESESSIONSFORSUBSCRIPTIONN_QUERY,
    variables: {
      request
    },
    fragments
  });
};
const CANCELSUBSCRIPTIONSOFUSERINSPECIFICCLASS_QUERY = "\n  mutation cancelSubscriptionsOfUserInSpecificClass($classId: Int!, $userId: Int, $customerId: Int) {\n    cancelSubscriptionsOfUserInSpecificClass(classId: $classId, userId: $userId, customerId: $customerId)\n  }";
export const cancelSubscriptionsOfUserInSpecificClassApiCall = async _ref16 => {
  let {
    classId,
    userId,
    customerId
  } = _ref16;
  return apiCall({
    query: CANCELSUBSCRIPTIONSOFUSERINSPECIFICCLASS_QUERY,
    variables: {
      classId,
      userId,
      customerId
    }
  });
};
const CHANGEUSERSESSIONSUBSCRIPTIONPRESENCE_QUERY = "\n  mutation changeUserSessionSubscriptionPresence($sessionId: Int!, $subscriptionId: JSON!, $presence: String!) {\n    changeUserSessionSubscriptionPresence(sessionId: $sessionId, subscriptionId: $subscriptionId, presence: $presence)\n    {\n      success\n\t\t\tmessage\n\t\t\tid\n\t\t\tid2\n\t\t\tname\n\t\t\tstatus\n      ...fragments\n    }\n  }";
export const changeUserSessionSubscriptionPresenceApiCall = async function (_ref17) {
  let {
    sessionId,
    subscriptionId,
    presence
  } = _ref17;
  let fragments = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;
  return apiCall({
    query: CHANGEUSERSESSIONSUBSCRIPTIONPRESENCE_QUERY,
    variables: {
      sessionId,
      subscriptionId,
      presence
    },
    fragments
  });
};
const CANCELSESSIONWITHALLSUBSCRIPTIONS_QUERY = "\n  mutation cancelSessionWithAllSubscriptions($id: Int!) {\n    cancelSessionWithAllSubscriptions(id: $id)\n    {\n      success\n\t\t\tmessage\n\t\t\tid\n\t\t\tid2\n\t\t\tname\n\t\t\tstatus\n      ...fragments\n    }\n  }";
export const cancelSessionWithAllSubscriptionsApiCall = async function (_ref18) {
  let {
    id
  } = _ref18;
  let fragments = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;
  return apiCall({
    query: CANCELSESSIONWITHALLSUBSCRIPTIONS_QUERY,
    variables: {
      id
    },
    fragments
  });
};
const CANCELMULTIPLESUBSCRIPTIONSSESSIONSBYIDS_QUERY = "\n  mutation cancelMultipleSubscriptionsSessionsByIds($subscriptionSessionsIds: JSON!, $inactiveOnly: Boolean, $cancelSession: Boolean) {\n    cancelMultipleSubscriptionsSessionsByIds(subscriptionSessionsIds: $subscriptionSessionsIds, inactiveOnly: $inactiveOnly, cancelSession: $cancelSession)\n    {\n      success\n\t\t\tmessage\n\t\t\tid\n\t\t\tid2\n\t\t\tname\n\t\t\tstatus\n      ...fragments\n    }\n  }";
export const cancelMultipleSubscriptionsSessionsByIdsApiCall = async function (_ref19) {
  let {
    subscriptionSessionsIds,
    inactiveOnly,
    cancelSession
  } = _ref19;
  let fragments = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;
  return apiCall({
    query: CANCELMULTIPLESUBSCRIPTIONSSESSIONSBYIDS_QUERY,
    variables: {
      subscriptionSessionsIds,
      inactiveOnly,
      cancelSession
    },
    fragments
  });
};